import React, { useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Redirect } from "react-router-dom";
import logo from "../assets/images/VioletCross.png";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";
import axios from "../api/index";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTriangleExclamation,
  faCircleExclamation,
} from "@fortawesome/free-solid-svg-icons";
import { login } from "../actions/auth";

const required = (value) => {
  if (!value) {
    return (
      <div className="alert alert-danger" role="alert">
        This field is required!
      </div>
    );
  }
};

const Payment = ({ paymentInstructions: paymentInstructionsProp }) => {
  // console.log("here ana fl payent");
  const form = useRef();
  const checkBtn = useRef();

  const [loading, setLoading] = useState(false);
  const [paymentInstructions, setPaymentInstructions] = useState("");

  const { isLoggedIn } = useSelector((state) => state.auth);
  const { message } = useSelector((state) => state.message);

  // Initialize from prop, and fallback to sessionStorage when prop is empty
  React.useEffect(() => {
    if (paymentInstructionsProp && paymentInstructionsProp.length > 0) {
      setPaymentInstructions(paymentInstructionsProp);
      return;
    }
    const paymentPage = sessionStorage.getItem("payment_page");
    if (paymentPage) {
      setPaymentInstructions(paymentPage);
    }
  }, [paymentInstructionsProp]);

  return (
    <div className="col-xl payment-container" style={{ direction: "rtl", textAlign: "right" }}>
      <div className="card-container-lg">
        <div className="container-logo" style={{ textAlign: "center" }}>
          <img src={logo} alt="Logo" style={{ width: 200, height: 200 }} />
        </div>

        <div className="alert alert-warning" style={{ textAlign: "center", direction: "rtl" }}>
          <h3>
            <FontAwesomeIcon
              icon={faTriangleExclamation}
              style={{ marginRight: "5px" }}
            />
            برجاء قراءة هذه الصفحة جيدًا{" "}
          </h3>
        </div>

        {/* Display payment instructions if available */}
        {paymentInstructions && (
          <div className="card" style={{ marginTop: "20px", direction: "rtl" }}>
            <div className="card-body" style={{ textAlign: "right", direction: "rtl" }}>
              <div 
                dangerouslySetInnerHTML={{ __html: paymentInstructions }}
                style={{ 
                  textAlign: "right", 
                  direction: "rtl",
                  fontFamily: "Arial, sans-serif",
                  wordWrap: "break-word",
                  overflowWrap: "break-word",
                  whiteSpace: "normal",
                  wordBreak: "normal",
                  unicodeBidi: "embed"
                }}
              />
            </div>
          </div>
        )}

      </div>
    </div>
  );
};

export default Payment;
